export const LOAD_OFFER_FINANCING_STRUCTURE_SUCCEEDED = "LOAD_OFFER_FINANCING_STRUCTURE_SUCCEEDED";

export const SAVE_OFFER_FINANCING_STRUCTURE_STARTED = "SAVE_OFFER_FINANCING_STRUCTURE_STARTED";
export const SAVE_OFFER_FINANCING_STRUCTURE_SUCCEEDED = "SAVE_OFFER_FINANCING_STRUCTURE_SUCCEEDED";
export const SAVE_OFFER_FINANCING_STRUCTURE_FAILED = "SAVE_OFFER_FINANCING_STRUCTURE_FAILED";

export const COMPUTE_OFFER_FINANCING_STRUCTURE_MAX_RESIDUAL_VALUE_STARTED =
  "COMPUTE_OFFER_FINANCING_STRUCTURE_MAX_RESIDUAL_VALUE_STARTED";
export const COMPUTE_OFFER_FINANCING_STRUCTURE_MAX_RESIDUAL_VALUE_SUCCEEDED =
  "COMPUTE_OFFER_FINANCING_STRUCTURE_MAX_RESIDUAL_VALUE_SUCCEEDED";
export const COMPUTE_OFFER_FINANCING_STRUCTURE_MAX_RESIDUAL_VALUE_FAILED =
  "COMPUTE_OFFER_FINANCING_STRUCTURE_MAX_RESIDUAL_VALUE_FAILED";

export const CANCEL_OFFER_FINANCING_STRUCTURE_CHANGES = "CANCEL_OFFER_FINANCING_STRUCTURE_CHANGES";

export const FINANCIAL_PRODUCT_ID_SET_SUCCEEDED = "FINANCIAL_PRODUCT_ID_SET_SUCCEEDED";
export const FINANCIAL_PRODUCT_ID_SET_FAILED = "FINANCIAL_PRODUCT_ID_SET_FAILED";

export const AVAILABLE_FINANCIAL_PRODUCTS_RETRIEVAL_SUCCEEDED = "AVAILABLE_FINANCIAL_PRODUCTS_RETRIEVAL_SUCCEEDED";
export const AVAILABLE_FINANCIAL_PRODUCTS_RETRIEVAL_FAILED = "AVAILABLE_FINANCIAL_PRODUCTS_RETRIEVAL_FAILED";
